import type {Iso8601DateTime} from "@vesta/common-type-definitions/typeDefinitions";
import {uniqueUuid} from "@vesta/unique/unique";
import {
    MOCK_LIFECYCLE_1_ID,
    MOCK_LIFECYCLE_2_ID,
    MOCK_LIFECYCLE_3_ID,
} from "~/components/entityProfile/lifecycle/mockCustomerProfileLifecycles";
import {ActivityCardType} from "~/modules/activityTimeline/types/activityTimeline.types";
import type {TimelineDayGroup} from "~/modules/activityTimeline/types/activityTimeline.types";

const TODAY = "2026-01-12" as const;
const YESTERDAY = "2026-01-11" as const;

const ts = (date: string, time: string): Iso8601DateTime => `${date}T${time}.000Z` as Iso8601DateTime;

/** Raw activity groups — `isInactive` is derived from lifecycle status in the mock API layer. */
export const MOCK_CUSTOMER_PROFILE_ACTIVITY_GROUPS: Array<TimelineDayGroup> = [
    {
        label: "Today",
        dateKey: TODAY,
        items: [
            {
                id: uniqueUuid`a1000001-0000-4000-8000-000000000001`,
                cardType: ActivityCardType.eventType,
                timestamp: ts(TODAY, "09:15:00"),
                status: "Completed",
                entityAction: "Call logged",
                context: "Outbound call — customer interested in X3 test ride next week.",
                createdBy: {kind: "user", displayName: "Priya Sharma", roleLabel: "Sales Agent"},
                journeyLabel: "J1",
                source: "Manual",
                lifecycleId: MOCK_LIFECYCLE_3_ID,
            },
            {
                id: uniqueUuid`a1000002-0000-4000-8000-000000000002`,
                cardType: ActivityCardType.eventType,
                timestamp: ts(TODAY, "11:40:00"),
                status: "Scheduled",
                entityAction: "Test ride booked",
                context: "Test ride scheduled at GKNM showroom for 14 Jan 2026.",
                createdBy: {kind: "user", displayName: "Rahul Mehta", roleLabel: "Sales Agent"},
                journeyLabel: "J1",
                ou: "GKNM showroom",
                lifecycleId: MOCK_LIFECYCLE_3_ID,
            },
            {
                id: uniqueUuid`a1000003-0000-4000-8000-000000000003`,
                cardType: ActivityCardType.dispositionChange,
                timestamp: ts(TODAY, "14:05:00"),
                entityAction: "Disposition changed",
                context: "Disposition changed from Warm lead to Hot lead",
                contextPrefix: "Disposition changed to ",
                contextOldValue: "Warm lead",
                contextNewValue: "Hot lead",
                createdBy: {kind: "user", displayName: "Priya Sharma", roleLabel: "Sales Agent"},
                journeyLabel: "J1",
                lifecycleId: MOCK_LIFECYCLE_3_ID,
            },
            {
                id: uniqueUuid`a1000004-0000-4000-8000-000000000004`,
                cardType: ActivityCardType.detailsChange,
                timestamp: ts(TODAY, "16:22:00"),
                entityAction: "Customer details updated",
                context: "Contact preferences updated",
                contextFieldChanges: [
                    {
                        fieldLabel: "Preferred contact time",
                        oldDisplay: "Morning",
                        newDisplay: "Evening",
                    },
                ],
                createdBy: {kind: "system", displayName: "System"},
                journeyLabel: "J1",
                lifecycleId: MOCK_LIFECYCLE_3_ID,
            },
        ],
    },
    {
        label: "Yesterday",
        dateKey: YESTERDAY,
        items: [
            {
                id: uniqueUuid`a1000007-0000-4000-8000-000000000007`,
                cardType: ActivityCardType.dispositionChange,
                timestamp: ts(YESTERDAY, "12:30:00"),
                entityAction: "Dispose",
                context: "Disposition changed from Not Connected-NR6 to Connected-Valid-Interested-Booked",
                contextPrefix: "Disposition changed to ",
                contextOldValue: "Not Connected-NR6",
                contextNewValue: "Connected-Valid-Interested-Booked",
                remarks: "Remark will come here",
                createdBy: {kind: "user", displayName: "Agent Name", roleLabel: "Sales Agent"},
                journeyLabel: "J1",
                source: "Google",
                ou: "Showroom",
                lifecycleId: MOCK_LIFECYCLE_2_ID,
            },
            {
                id: uniqueUuid`a1000008-0000-4000-8000-000000000008`,
                cardType: ActivityCardType.agentChange,
                timestamp: ts(YESTERDAY, "12:30:00"),
                entityAction: "Ownership Transferred",
                context: "Aslesha - Harsih",
                createdBy: {kind: "system", displayName: "System"},
                journeyLabel: "J1",
                source: "Google",
                ou: "Showroom",
                lifecycleId: MOCK_LIFECYCLE_3_ID,
            },
            {
                id: uniqueUuid`a1000005-0000-4000-8000-000000000005`,
                cardType: ActivityCardType.eventType,
                timestamp: ts(YESTERDAY, "10:30:00"),
                status: "Completed",
                entityAction: "Walk-in logged",
                context: "Customer visited GKNM showroom and enquired about X3 pricing.",
                createdBy: {kind: "user", displayName: "Ananya Reddy", roleLabel: "Showroom Manager"},
                journeyLabel: "J2",
                ou: "GKNM showroom",
                source: "Walk-in",
                lifecycleId: MOCK_LIFECYCLE_2_ID,
            },
        ],
    },
    {
        label: "7 Jun 2026",
        dateKey: "2026-06-07",
        defaultOpen: false,
        items: [
            {
                id: uniqueUuid`a1000009-0000-4000-8000-000000000009`,
                cardType: ActivityCardType.eventType,
                timestamp: ts("2026-06-07", "09:00:00"),
                entityAction: "Call logged",
                context: "Follow-up call from inactive lifecycle.",
                createdBy: {kind: "user", displayName: "Priya Sharma", roleLabel: "Sales Agent"},
                journeyLabel: "J3",
                lifecycleId: MOCK_LIFECYCLE_1_ID,
            },
        ],
    },
];
